import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Utility } from 'src/app/core/common';
import { MatchingService } from 'src/app/services/matching.service';

@Component({
  selector: 'app-search-list',
  templateUrl: './search-list.component.html',
  styleUrls: ['./search-list.component.scss']
})
export class SearchListComponent implements OnInit {
  constructor(private store: Store, private matchingService: MatchingService) { }

  Utility = Utility;
  user: any;
  searches: any[];
  // queries: { [key: string]: number } = {};

  async ngOnInit() {
    await new Promise<void>(async () => await this.load());
  }

  async load() {
    this.user = Utility.clone(this.store.selectSnapshot(state => state.auth.user));
    this.searches = await this.matchingService.newCount();
  }

  // async save() {
  //   this.spinner.show();
  //   await this.userService.saveResume(this.user);
  //   await this.store.dispatch(Current).toPromise();
  //   this.load();
  //   this.spinner.hide();
  //   this.toastr.success('تغییرات ذخیره شد.');
  // }
  // removeMatch(i: number) {
  //   this.user.Seeker.JobAlert.Searches.splice(i, 1);
  //   this.save();
  // }
  // matchLastDate(match: any) {
  //   if (!this.searches) { return false; }
  //   const search = this.searches.find(_ => _.Query == match.Query);
  //   let time = new Date(match.LastDate).getTime();
  //   if (isNaN(time)) { time = 0; }
  //   return new Date(Math.max(search.LastDate ? new Date(search.LastDate).getTime() : 0, time));
  // }
  // isMatching(search: any) {
  //   return this.user.Seeker.JobAlert && this.user.Seeker.JobAlert.Searches &&
  //     this.user.Seeker.JobAlert.Searches.findIndex(_ => _.Query == search.Query) >= 0;
  // }
  // addMatching(search: any) {
  //   if (!this.user.Seeker.JobAlert) { this.user.Seeker.JobAlert = {}; }
  //   if (!this.user.Seeker.JobAlert.Searches) { this.user.Seeker.JobAlert.Searches = []; }
  //   this.user.Seeker.JobAlert.Searches.push({ Query: search.Query });
  //   this.save();
  // }
}
